import { initializeYup } from "@duosoftbg/nacid-components";
import * as yup from "yup";

export const vProfQualificationsSearchTable = () => {
  initializeYup(yup);
  return yup.object({});
};

export const vARNacidSearchTable = () => {
  initializeYup(yup);
  return yup.object({});
};

export const vARUniversitySearchTable = () => {
  initializeYup(yup);
  return yup.object({});
};
